import { render } from "./AlquileresCard.vue?vue&type=template&id=28d90940"
import script from "./AlquileresCard.vue?vue&type=script&lang=js"
export * from "./AlquileresCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__